import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {setDSDocumentsOpened, setDSDocumentsSubModule, getDSDocumentConfig, setAppModule, setDSDocumentsOpenedPackage,
    setDSWizard, setOpenInvitationEditor} from 'state/actions'
import DetailedDocument from './detailedDocument'
import DocumentsList from './documentsList'
import styles from './documents.scss'
import i18n from 'lib/i18n'
import cs from 'classnames'
import * as c from 'state/constants'
import nesProp from 'nested-property'
//import DSWizard from './DSWizard'
import MifidButton from './mifidButton'
import DetailedPackage from './detailedPackage'

const _ = i18n('dsdocuments')

@connect(
	({
        DSDocuments: {items, modalIsOpen, opened, subModule, config, paginatedPackages, totalPackageRecords, openedPackage},
        app: {security, lang, previousModule}
    }) => ({
        items,
        modalIsOpen,
        opened,
        subModule,
        security,
        lang,
        previousModule,
        paginatedPackages,
        totalPackageRecords,
        openedPackage
    })
)
export default class DSDocuments extends Component {
	static propTypes = {
		items: PropTypes.arrayOf(PropTypes.object),
		modalIsOpen: PropTypes.bool,
        opened: PropTypes.string,
        security: PropTypes.object,
        subModule: PropTypes.string,
    }

    constructor(props) {
        super(props)
        this.state = {canCreateMifid: false, forceOpenWizard: false}
    }

    componentWillMount() {
        const {dispatch, config, security} = this.props

        if (!config || Object.keys(config).length === 0) {
            dispatch(getDSDocumentConfig(c.DIGITAL_SIGNATURE_SETTINGS))
        }

        security.actions.map((item, key) => {
            if (item.actionName == 'createmifid') {
                this.setState({canCreateMifid: item.actionAllowed === "true" ? true: false})
            }
        })
    }

    /**
     * This function navigate to the detailed overview of a sent email and set seen that email.
     */
    zoomTo = (dsPackage, forceOpenWizard = false, forceOpenInvitationEditor = false) => {
        const {dispatch} = this.props
        this.setState({forceOpenWizard, forceOpenInvitationEditor})
        dispatch(setDSDocumentsOpenedPackage(dsPackage._id))
        dispatch(setDSDocumentsSubModule('detailedPackage'))
        if(forceOpenWizard) {
            dispatch(setDSWizard(true))
        }
        if(forceOpenInvitationEditor) {
            dispatch(setOpenInvitationEditor(true))
        }
    }

    /**
     * This function will close the detailed page of an email.
     */
    zoomOut = () => {
		const {dispatch} = this.props
        dispatch(setDSDocumentsOpenedPackage())
        dispatch(setDSDocumentsSubModule())
    }

    navigateBackToInbox = () => {
        const {dispatch, previousModule} = this.props
        dispatch(setAppModule(previousModule))
    }

    render() {
        const {opened, previousModule, paginatedPackages, totalPackageRecords, openedPackage} = this.props
        const {forceOpenWizard, forceOpenInvitationEditor} = this.state
        return (
            <div id={`${styles.outboxModule}`}>
                <div className={styles.mainTitleDiv}>
                    <div className={`${styles.mainTitleContainer}`}>
                        <h2 className={`${styles.mainTitle}`}>
                            {_('title')}
                        </h2>
                        <h3>{_('subtitle')}</h3>
                    </div>
                    {previousModule && previousModule === "INBOX"?
                        <div className={styles.moduleControls}>
                            <button onClick={this.navigateBackToInbox}
                                className={`${styles.backToList} ${styles.greyButton} ${opened ? 'visible' : styles.hidden}`}>
                                {_('backToInbox')}
                            </button>
                        </div>
                        :
                        <div className={styles.moduleControls}>
                            <button onClick={this.zoomOut}
                                className={`${styles.backToList} ${styles.greyButton} ${opened ? 'visible' : styles.hidden}`}>
                                {_('backToList')}
                            </button>
                        </div>
                    }
                </div>

                {!openedPackage && <DocumentsList paginatedPackages={paginatedPackages} totalRecords={totalPackageRecords} zoomTo={this.zoomTo}/>}
                {openedPackage &&
                <DetailedPackage
                    zoomOut={this.zoomOut}
                    forceOpenWizard={forceOpenWizard}
                    forceOpenInvitationEditor={forceOpenInvitationEditor}
                />}
            </div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/DSDocuments/index.jsx